class $365480cad2bbacec$export$29b488039e3d4c2d {
    constructor(_status = 0, _text = "Network Error"){
        this.status = _status;
        this.text = _text;
    }
}


const $050ad26521b99438$export$2b84f07db8df86ee = ()=>{
    if (typeof localStorage === "undefined") return;
    return {
        get: (key)=>Promise.resolve(localStorage.getItem(key)),
        set: (key, value)=>Promise.resolve(localStorage.setItem(key, value)),
        remove: (key)=>Promise.resolve(localStorage.removeItem(key))
    };
};


const $c798475fc5eb7ae4$export$6f57813fe9f31bf9 = {
    origin: "https://api.emailjs.com",
    blockHeadless: false,
    storageProvider: (0, $050ad26521b99438$export$2b84f07db8df86ee)()
};


const $0b89b563b8ce5c16$export$ecbd7d678ac4909b = (options)=>{
    if (!options) return {};
    // support compatibility with SDK v3
    if (typeof options === "string") return {
        publicKey: options
    };
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (options.toString() === "[object Object]") return options;
    return {};
};


const $521ca2b4a362b637$export$2cd8252107eb640b = (options, origin = "https://api.emailjs.com")=>{
    if (!options) return;
    const opts = (0, $0b89b563b8ce5c16$export$ecbd7d678ac4909b)(options);
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).publicKey = opts.publicKey;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockHeadless = opts.blockHeadless;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).storageProvider = opts.storageProvider;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockList = opts.blockList;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).limitRate = opts.limitRate;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).origin = opts.origin || origin;
};





const $ec190f1f3b1ae57b$export$4a68059d3a005c64 = async (url, data, headers = {})=>{
    const response = await fetch((0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).origin + url, {
        method: "POST",
        headers: headers,
        body: data
    });
    const message = await response.text();
    const responseStatus = new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(response.status, message);
    if (response.ok) return responseStatus;
    throw responseStatus;
};



const $90a7819081cf59b4$export$1f3bf48e9edf7d72 = (publicKey, serviceID, templateID)=>{
    if (!publicKey || typeof publicKey !== "string") throw "The public key is required. Visit https://dashboard.emailjs.com/admin/account";
    if (!serviceID || typeof serviceID !== "string") throw "The service ID is required. Visit https://dashboard.emailjs.com/admin";
    if (!templateID || typeof templateID !== "string") throw "The template ID is required. Visit https://dashboard.emailjs.com/admin/templates";
};


const $606788fef0a93b78$export$80b670b04253020b = (templateParams)=>{
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (templateParams && templateParams.toString() !== "[object Object]") throw "The template params have to be the object. Visit https://www.emailjs.com/docs/sdk/send/";
};


const $9e97281bc02a549f$export$b509da924d51a9a9 = (navigator)=>{
    return navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
};



const $ab7d2fa3f7df0c38$export$a8135c843594e85b = ()=>{
    return new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(451, "Unavailable For Headless Browser");
};


const $d4556afef3d17824$export$1727dd877829fee8 = (list, watchVariable)=>{
    if (!Array.isArray(list)) throw "The BlockList list has to be an array";
    if (typeof watchVariable !== "string") throw "The BlockList watchVariable has to be a string";
};


const $52e7c6c8b64bb1c0$var$isBlockListDisabled = (options)=>{
    return !options.list?.length || !options.watchVariable;
};
const $52e7c6c8b64bb1c0$var$getValue = (data, name)=>{
    return data instanceof FormData ? data.get(name) : data[name];
};
const $52e7c6c8b64bb1c0$export$c7ab883573eb12a4 = (options, params)=>{
    if ($52e7c6c8b64bb1c0$var$isBlockListDisabled(options)) return false;
    (0, $d4556afef3d17824$export$1727dd877829fee8)(options.list, options.watchVariable);
    const value = $52e7c6c8b64bb1c0$var$getValue(params, options.watchVariable);
    if (typeof value !== "string") return false;
    return options.list.includes(value);
};



const $e033b5517693ceb4$export$b30160cec00781e = ()=>{
    return new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(403, "Forbidden");
};


const $f1b4a42f5460eb37$export$88c64f8d5fea404b = (throttle, id)=>{
    if (typeof throttle !== "number" || throttle < 0) throw "The LimitRate throttle has to be a positive number";
    if (id && typeof id !== "string") throw "The LimitRate ID has to be a string";
};


const $ccb9264e82a8b92f$var$getLeftTime = async (id, throttle, storage)=>{
    const lastTime = Number(await storage.get(id) || 0);
    return throttle - Date.now() + lastTime;
};
const $ccb9264e82a8b92f$export$8b7f6a1a004faa27 = async (defaultID, options, storage)=>{
    if (!options.throttle || !storage) return false;
    (0, $f1b4a42f5460eb37$export$88c64f8d5fea404b)(options.throttle, options.id);
    const id = options.id || defaultID;
    const leftTime = await $ccb9264e82a8b92f$var$getLeftTime(id, options.throttle, storage);
    if (leftTime > 0) return true;
    await storage.set(id, Date.now().toString());
    return false;
};



const $0c0740911a700545$export$29b72785a20a20d9 = ()=>{
    return new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(429, "Too Many Requests");
};


const $4e1a944052b5621b$export$89db4734f6c919c4 = async (serviceID, templateID, templateParams, options)=>{
    const opts = (0, $0b89b563b8ce5c16$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $9e97281bc02a549f$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $ab7d2fa3f7df0c38$export$a8135c843594e85b)());
    (0, $90a7819081cf59b4$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $606788fef0a93b78$export$80b670b04253020b)(templateParams);
    if (templateParams && (0, $52e7c6c8b64bb1c0$export$c7ab883573eb12a4)(blockList, templateParams)) return Promise.reject((0, $e033b5517693ceb4$export$b30160cec00781e)());
    if (await (0, $ccb9264e82a8b92f$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $0c0740911a700545$export$29b72785a20a20d9)());
    const params = {
        lib_version: "4.3.3",
        user_id: publicKey,
        service_id: serviceID,
        template_id: templateID,
        template_params: templateParams
    };
    return (0, $ec190f1f3b1ae57b$export$4a68059d3a005c64)("/api/v1.0/email/send", JSON.stringify(params), {
        "Content-type": "application/json"
    });
};





const $fb360b4e9f3d39cc$export$ed692cabb252e59b = (form)=>{
    if (!form || form.nodeName !== "FORM") throw "The 3rd parameter is expected to be the HTML form element or the style selector of the form";
};









const $4a4df2b20f870b5d$var$findHTMLForm = (form)=>{
    return typeof form === "string" ? document.querySelector(form) : form;
};
const $4a4df2b20f870b5d$export$c13a0f9407ffb567 = async (serviceID, templateID, form, options)=>{
    const opts = (0, $0b89b563b8ce5c16$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $9e97281bc02a549f$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $ab7d2fa3f7df0c38$export$a8135c843594e85b)());
    const currentForm = $4a4df2b20f870b5d$var$findHTMLForm(form);
    (0, $90a7819081cf59b4$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $fb360b4e9f3d39cc$export$ed692cabb252e59b)(currentForm);
    const formData = new FormData(currentForm);
    if ((0, $52e7c6c8b64bb1c0$export$c7ab883573eb12a4)(blockList, formData)) return Promise.reject((0, $e033b5517693ceb4$export$b30160cec00781e)());
    if (await (0, $ccb9264e82a8b92f$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $0c0740911a700545$export$29b72785a20a20d9)());
    formData.append("lib_version", "4.3.3");
    formData.append("service_id", serviceID);
    formData.append("template_id", templateID);
    formData.append("user_id", publicKey);
    return (0, $ec190f1f3b1ae57b$export$4a68059d3a005c64)("/api/v1.0/email/send-form", formData);
};


var $e8e08de5e84870c6$export$2e2bcd8739ae039 = {
    init: $521ca2b4a362b637$export$2cd8252107eb640b,
    send: $4e1a944052b5621b$export$89db4734f6c919c4,
    sendForm: $4a4df2b20f870b5d$export$c13a0f9407ffb567,
    EmailJSResponseStatus: $365480cad2bbacec$export$29b488039e3d4c2d
};


(0, $e8e08de5e84870c6$export$2e2bcd8739ae039).init("user_YxP8w6mA1FpMnzGbet6Iz");
async function $0535227c81c4387a$export$89c2621768820c8b() {
    let message;
    let errorMessage = document.querySelector("#error");
    let successMessage = document.querySelector("#success");
    let submitButton = document.querySelector("#submit-button");
    submitButton.disabled = true;
    (0, $e8e08de5e84870c6$export$2e2bcd8739ae039).sendForm("service_fl5i2he", "template_af8j9pd", "#contact-form").then(function(response) {
        message = "Message was sent successfully!";
        alert(message);
        submitButton.disabled = false;
        successMessage.innerHTML = message;
    }, function(error) {
        message = "Something went wrong";
        alert(message);
        submitButton.disabled = false;
        errorMessage.innerHTML = message;
    });
}


//# sourceMappingURL=index.46053114.js.map
